import { SmsCountryPreferences } from 'modules/graphql';
import { forwardRef, useState } from 'react';
import { Archive, Edit16, Overflow } from 'ui/icons';
import { ALIGNMENT } from 'ui/menu';
import { BasicSelect } from 'ui/selects';
import { colors } from 'ui/theme';
import { DISPLAY_CONTENT } from '../constants';
import { Frequency } from '../types';
import { EditPreferencesModal, VersionHistoryModal } from './modals';
import { OverflowOption, StyledOverflowButton, StyledSelectOptionsContainer } from './styles';

const { overflowEditInstructionsLabel, overflowVersionHistoryLabel } = DISPLAY_CONTENT.contentTable;

type Props = Pick<
  SmsCountryPreferences,
  'regionCode' | 'regionName' | 'alphanumericOptOut' | 'numericOptOut' | 'frequency'
>;

export const OverflowSelect = ({
  regionCode,
  regionName,
  alphanumericOptOut,
  numericOptOut,
  frequency,
}: Props) => {
  const [isEditInstructionsModalOpen, setIsEditInstructionsModalOpen] = useState(false);
  const [isVersionHistoryModalOpen, setIsVersionHistoryModalOpen] = useState(false);

  const optionsContent = [
    {
      id: 'overflow-edit-instructions',
      labelText: overflowEditInstructionsLabel,
      onClick: () => setIsEditInstructionsModalOpen(true),
      Prefix: <Edit16 color={colors.grey60} width={20} />,
    },
    {
      id: 'overflow-version-history',
      labelText: overflowVersionHistoryLabel,
      onClick: () => setIsVersionHistoryModalOpen(true),
      Prefix: <Archive color={colors.grey60} width={20} />,
    },
  ];

  const selectOptions = optionsContent.map(({ id, labelText, onClick, Prefix }) => ({
    id,
    label: (
      <OverflowOption data-test={`${id}-option`} onClick={onClick}>
        {Prefix}
        {labelText}
      </OverflowOption>
    ),
    value: id,
  }));

  return (
    <>
      <BasicSelect
        data-test="overflow-select"
        id="overflow-select"
        options={selectOptions}
        shouldFocusOnFirstElementByDefault={false}
        horizontalAlignment={ALIGNMENT.RIGHT}
        SelectOptionsContainer={StyledSelectOptionsContainer}
        Trigger={forwardRef<HTMLButtonElement, any>(({ toggleDropdown }, ref) => (
          <StyledOverflowButton
            data-test="overflow-trigger"
            innerRef={ref}
            onClick={toggleDropdown}
          >
            <Overflow />
          </StyledOverflowButton>
        ))}
      />
      {isEditInstructionsModalOpen && (
        <EditPreferencesModal
          regionCode={regionCode || ''}
          regionName={regionName || ''}
          alphanumericOptOut={alphanumericOptOut || ''}
          numericOptOut={numericOptOut || ''}
          frequency={frequency || Frequency.DISABLED}
          isModalOpen={isEditInstructionsModalOpen}
          setIsModalOpen={setIsEditInstructionsModalOpen}
        />
      )}
      {isVersionHistoryModalOpen && (
        <VersionHistoryModal
          regionCode={regionCode || ''}
          regionName={regionName || ''}
          isModalOpen={isVersionHistoryModalOpen}
          setIsModalOpen={setIsVersionHistoryModalOpen}
        />
      )}
    </>
  );
};
